<div class="flex max-w-screen-xl w-full mx-auto flex-col lg:flex-row gap-5 bg-white rounded-3xl shadow-tertiary">
  <div class="flex flex-col gap-20 w-full p-8 privacy-policy-section">
    <div class="flex flex-col gap-4">
      <h2 class="title">{{ "privacy_policy.title" | translate }}</h2>

      <ul class="flex flex-col gap-2 !list-disc !list-inside">
        @for (message of ('privacy_policy.points' | translate); track message) {
          <li class="subtitle" [innerHTML]="message"></li>
        } 
      </ul>
    </div>
  </div>
</div>